import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  // Batch size validation
  if (properties.batchSize === undefined || properties.batchSize === null) {
    errors.push({
      key: 'batchSize',
      message: 'Batch size is required',
    });
  } else if (properties.batchSize < 1) {
    errors.push({
      key: 'batchSize',
      message: 'Batch size must be at least 1',
    });
  } else if (properties.batchSize > 10000) {
    errors.push({
      key: 'batchSize',
      message: 'Batch size cannot exceed 10,000',
    });
  } else if (!Number.isInteger(properties.batchSize)) {
    errors.push({
      key: 'batchSize',
      message: 'Batch size must be a whole number',
    });
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
